import axios from 'axios';

// 新闻数据类型定义
export interface NewsItem {
  _id: string;
  title: string;
  content: string;
  summary?: string;
  coverImage?: string;
  status: string;
  publishDate: string;
  isTop: boolean;
  tags?: string[];
  author?: {
    _id: string;
    username: string;
    email: string;
  };
  viewCount: number;
  createdAt: string;
  updatedAt: string;
}

export interface NewsResponse {
  news: NewsItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

// 创建axios实例
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://admin.jieyudayaofang.com/api',
  timeout: 10000,
});

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    // 可以在这里添加认证token等
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.error('API请求错误:', error);
    return Promise.reject(error);
  }
);

// 图片相关API
export const imageAPI = {
  // 获取图片列表
  getImages: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    category?: string;
  }) => {
    return api.get('/images', { params });
  },

  // 根据分类获取图片
  getImagesByCategory: (category: string) => {
    return api.get('/images', { 
      params: { 
        category,
        limit: 50,
        page: 1
      } 
    });
  },

  // 获取轮播图数据
  getCarouselImages: () => {
    return api.get('/images/carousel');
  },

  // 获取新闻页头图片数据
  getNewsHeaderImages: () => {
    return api.get('/images/news-header');
  },

  // 获取单个图片
  getImage: (id: string) => {
    return api.get(`/images/${id}`);
  },
};

// 新闻相关API
export const newsAPI = {
  // 获取新闻列表
  getNews: (params?: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
  }): Promise<NewsResponse> => {
    return api.get('/news', { params });
  },
  
  // 获取单个新闻详情
  getNewsById: (id: string): Promise<{ news: NewsItem }> => {
    return api.get(`/news/${id}`);
  },
};

export default api; 